const dateFormat = 'DD MMM YYYY';
const dateFormat2 = 'DD MMM YYYY, HH:mm';
const dateFormat3 = 'DD MMM YYYY HH:mm';

export { dateFormat, dateFormat2, dateFormat3 };
